import { Component } from '@angular/core';
import { Device } from '@ionic-native/device/ngx';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { PageHeadingService } from 'src/app/services/page-heading-service/page-heading.service';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { AppSettings } from 'src/app/utils/app-settings';
import { MenuUtils } from 'src/app/utils/menu-utils';
import { pages } from 'src/app/utils/pages';
import { EmergencyContact } from '../../models/emergency-contact';
import { EmergencyContactService } from '../../services/emergency-contact.service';

@Component({
  selector: 'app-emergency-contact',
  templateUrl: './emergency-contact.component.html',
  styleUrls: ['./emergency-contact.component.scss']
})
export class EmergencyContactComponent extends ComponentBase {

  constructor(private routingService: RoutingService
    , public device: Device
    , private pageHeadingService: PageHeadingService
    , private emergencyContactService: EmergencyContactService) {
    super();
  }

  emergency_contact: EmergencyContact;
  public showEmgContactFileSelector = {};
  showEmgContactImage: boolean = true;
  errorMessage: string = null;
  imageUrl = `${AppSettings.apiUrl}emergencycontact/###/photo`
  emgContact_force_reload = false;
  ngOnInit() {
    this.emgContact_force_reload = this.emergencyContactService.force_reload_photo;
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem(pages.emergencyContact));
    let sub = this.emergencyContactService.getEmergencyContactForStudent()
      .subscribe((emgContact) => {
        this.emergency_contact = emgContact;
      });
    this.addSubscription(sub);
  }

  onEmergencyContactEdit(addNew: boolean) {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'edit-emergency-contact'];
    route.append_current_url_to_history = true;
    if (addNew) {
      route.query_params = { addNew: "true" };
    }
    else {
      route.query_params = { addNew: "false" };
    }
    this.routingService.navigate(route);
  }

  onChangeEmgContactPhoto(id: number) {
    this.showEmgContactFileSelector[id] = true;
  }

  onEmgContactFileSelect(id: number, files: Array<File>) {
    this.showEmgContactImage = false;
    this.showEmgContactFileSelector[id] = false;
    let selectedFile = files[0];
    this.emergencyContactService.updatePhoto(id, selectedFile)
      .subscribe(res => {
        if (res.message) {
          this.errorMessage = res.message;
          setTimeout(() => {
            this.errorMessage = null;
          }, 3000);
        }
        this.emgContact_force_reload = true;
        this.showEmgContactImage = true;
      });
  }
}
